import { Reducer } from 'redux';

import type { changeAnyWallet } from 'reduxState/wallet/walletReducer';

// Actions

export const setReferralCode = (code: string | undefined) => ({
  type: 'SET_REFERRAL_CODE' as const,
  code,
});

// export const setReferralIsValid = () => ({
//   type: 'SET_REFERRAL_VALIDATED' as const,
// });

export const setLastReferralPayoutAt = (timestamp: number) => ({
  type: 'SET_LAST_REFERRAL_PAYOUT' as const,
  lastReferralPayoutAt: timestamp,
});

export const setReferralCodeApplied = (active: boolean) => ({
  type: 'SET_REFERRAL_CODE_APPLIED' as const,
  active,
});

// Reducer

type UserReferral = {
  referralCode?: string;
  lastReferralPayoutAt?: number;
  /** Display banner after applied */
  referralCodeApplied?: boolean;
};

type ReferralAction =
  | ReturnType<
      | typeof setReferralCode
      | typeof setLastReferralPayoutAt
      | typeof setReferralCodeApplied
      // | typeof setReferralIsValid
    >
  | changeAnyWallet;

const defaultState: UserReferral = {
  referralCode: undefined,
  lastReferralPayoutAt: undefined,
  referralCodeApplied: undefined,
};

/** @cached */
export const userReferralReducer: Reducer<UserReferral, ReferralAction> = (
  state = defaultState,
  action
): UserReferral => {
  switch (action.type) {
    case 'CHANGE_WALLET':
      // NOTE: We cannot remove code on wallet removal,
      //  as it's also called in Unlock process and would break flow
      return {
        ...state,
        lastReferralPayoutAt: defaultState.lastReferralPayoutAt,
      };
    case 'SET_LAST_REFERRAL_PAYOUT':
      return {
        ...state,
        lastReferralPayoutAt: action.lastReferralPayoutAt,
      };
    case 'SET_REFERRAL_CODE':
      return {
        ...state,
        referralCode: action.code,
        referralCodeApplied: false,
      };
    case 'SET_REFERRAL_CODE_APPLIED':
      return {
        ...state,
        // Remove existing applied code
        referralCode: undefined,
        referralCodeApplied: action.active || undefined,
      };
    default:
      return state;
  }
};
